






import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import EditOfferReport from '@/business/project/components/edit-project/edit-offer-report.vue'

@Component({
  name: 'project-settings',
  components: { EditOfferReport },
})
export default class OfferReportSettingsPage extends Vue {
  @Prop()
  readonly offerId!: number

  @Prop()
  readonly type!: 'create' | 'edit'
}
